export default {
  doctor: {
    doctor: "پزشک",
    patient: "بیمار",
    createdAt: "تاریخ",
    receptionType: "علت مراجعه",
    service: "خدمت",
    insurance: "بیمه",
    tax: "مالیات",
    doctorTax: "مالیات پزشک",
    hospitalTax: "مالیات مرکز",
    doctorDiscountShare: "تخفیف پزشک",
    hospitalDiscountShare: "تخفیف مرکز",
    doctorReturnShare: "استرداد پزشک",
    hospitalReturnShare: "استرداد مرکز",
    totalAmount: "مبلغ",
    doctorShare: "سهم پزشک",
    hospitalShare: "سهم مرکز",
    fromDate: "از تاریخ",
    toDate: "تا تاریخ",
    totalDoctorsShare: "مجموع سهم پزشک",
    totalHospitalsShare: "مجموع سهم مرکز",
    totalDoctorsTax: "مجموع مالیات پزشک",
    totalHospitalsTax: "مجموع مالیات مرکز",
    totalDoctorsDiscountShare: "مجموع تخفیف پزشک",
    totalHospitalsDiscountShare: "مجموع تخفیف مرکز",
    totalDoctorsReturnShare: "مجموع استرداد پزشک",
    totalHospitalsReturnShare: "مجموع استرداد مرکز",
    totalServicesAmount: "مجموع مبلغ سرویس ها",
    doctorReturnDiscountShare: "تخفیف دکتر از استرداد",
    hospitalReturnDiscountShare: "تخفیف مرکز از استرداد",
    totalOfDoctorReturnDiscount: "مجموع تخفیف دکتر از استرداد",
    totalOfHospitalReturnDiscount: "مجموع تخفیف مرکز از استرداد",
    total: 'مجموع'
  },
  unit: {
    doctor: "پزشک",
    patient: "بیمار",
    createdAt: "تاریخ پذیرش",
    receptionType: "علت مراجعه",
    insurance: "بیمه",
    tax: "مالیات",
    doctorTax: "مالیات پزشک",
    hospitalTax: "مالیات مرکز",
    doctorDiscountShare: "تخفیف پزشک",
    hospitalDiscountShare: "تخفیف مرکز",
    doctorReturnShare: "استرداد پزشک",
    hospitalReturnShare: "استرداد مرکز",
    totalAmount: "مبلغ",
    doctorShare: "سهم پزشک",
    hospitalShare: "سهم مرکز",
    fromDate: "از تاریخ",
    toDate: "تا تاریخ",
    serviceCategory: "نوع خدمت",
    services: "خدمات",
    unit: "واحد",
    createdUser: "پذیرش کننده",
    referralWay: "نحوه‌ی آشنایی",
    firstVisit: "اولین مراجعه",
    allVisits: "همه مراجعات",
    countOfReferrals: "تعداد مراجعات",
    totalReceptionsCount: " مجموع تعداد پذیرش",
    service: {
      serviceName: "عنوان",
      total: "مبلغ",
      beneficiaryDoctor: "پزشک",
    },
    payments: "پرداخت ها",
    payment: {
      paymentMethod: "نوع",
      amount: "مبلغ",
      createdUser: "صندوقدار",
      createdAt: "تاریخ پرداخت",
    },
    averageWaitingTime: "متوسط زمان انتظار بیمار",
    averageVisitTime: "متوسط زمان ویزیت بیمار",
    waiting: "زمان انتظار",
    visitTime: "زمان ویزیت",
  },
  cashier: {
    cashierReport: "گزارش صندوق",
    cashier: "صندوقدار",
    patient: "بیمار",
    createdAt: "تاریخ پذیرش",
    // receptionType: 'علت مراجعه',
    services: "خدمات",
    service: {
      serviceName: "عنوان",
      total: "مبلغ",
      beneficiaryDoctor: "پزشک",
    },
    payments: "پرداخت ها",
    payment: {
      paymentMethod: "نوع",
      amount: "مبلغ",
      createdAt: "تاریخ پرداخت",
    },
    // insurance: 'بیمه',
    // tax: 'مالیات',
    // doctorTax: 'مالیات پزشک',
    // hospitalTax: 'مالیات مرکز',
    // doctorDiscountShare: 'تخفیف پزشک',
    // hospitalDiscountShare: 'تخفیف مرکز',
    // totalAmount: 'مبلغ',
    // doctorShare: 'سهم پزشک',
    // hospitalShare: 'سهم مرکز',
    fromDate: "از تاریخ",
    toDate: "تا تاریخ",
    fromTime: "از ساعت",
    toTime: "تا ساعت",
    paymentsSum: "مجموع پرداخت ها",
    paymentType: "نحوه پرداخت",
    units: "واحدها",
  },
  return: {
    returnReport: "گزارش استرداد",
    return: "استرداد",
    returnAmount: "مبلغ استرداد",
    patient: "بیمار",
    createdAt: "تاریخ",
    unit: "واحد",
    paymentType:'نحوه استرداد وجه',
    units: "واحدها",
    description: "علت استرداد",
    fromDate: "از تاریخ",
    toDate: "تا تاریخ",
    cashier: "صندوقدار",
    fromTime: "از ساعت",
    toTime: "تا ساعت",
    paymentsSum: "مجموع پرداخت ها",
    totalSum: 'جمع کل',
    services: 'خدمات'

  },
};
